<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Group Greeter
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <div class="row justify-content-end">
                                <div class="col-auto d-flex align-items-center gap-2 flex-nowrap">
                                    <a v-on:click="toggleModal('add_group_greeter')" class="btn btn-primary text-white" style="width: 180px;">
                                        <i class="fas fa-plus fs-16"></i> Tambah Data
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="groupGreeterQuota == -1" class="alert alert-success" role="alert">
                <div class="alert-content">
                    <p>Batas group greeter maksimal anda adalah <b>Unlimited</b> group greeter</p>
                </div>
            </div>
            <div v-else-if="groupGreeterQuota == 0" class="alert alert-danger" role="alert">
                <div class="alert-content">
                    <p>Batas group greeter maksimal anda adalah <b>{{ groupGreeterQuota }}</b> group greeter</p>
                </div>
            </div>
            <div v-else class="alert alert-primary" role="alert">
                <div class="alert-content">
                    <p>Batas group greeter maksimal anda adalah <b>{{ groupGreeterQuota }}</b> group greeter</p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <GroupGreeterTable v-if="renderTable" :date="date" />
                    </div>
                </div>
            </div>

            <modal name="add_group_greeter" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddGroupGreeter />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import GroupGreeterTable from "@/components/tables/GroupGreeter.vue";
    import AddGroupGreeter from "@/components/forms/group-greeter/Add.vue";

    export default {
        components: {
            GroupGreeterTable,
            AddGroupGreeter
        },
        data() {
            return {
                group_dropdown: [],
                exportJson: [],
                date: "",
                renderTable: false,
                groupGreeterQuota: 0
            };
        },
        beforeDestroy() {
            this.$root.$off("toggle_modal", this.fnToggleModal);
            this.$root.$off("refresh_data", this.fnRefreshData);
        },
        mounted() {
            this.groupGreeterQuota = this.$store.state.auth.package.group_greeter

            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.fnRefreshData = () => {
                this.renderTable = false
                this.$nextTick(() => {
                    this.renderTable = true
                })
            }
            this.$root.$on("refresh_data", this.fnRefreshData);
            
            //get current date from url
            this.date = this.$route.query.date

            if (!this.date) {
                this.date = new Date().toISOString().split('T')[0]
            }

            this.renderTable = true

        },
        watch: {
            date: function() {
                this.renderTable = false
                this.$nextTick(() => {
                    this.renderTable = true
                })
            }
        },
        methods: {
            toggleModal(param) {
                this.$modal.toggle(param);
            }
        },
    };
</script>